"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedInput = void 0;
const react_1 = __importStar(require("react"));
const format_mask_1 = require("../../lib/format-mask");
const utils_1 = require("../../lib/utils");
const icon_1 = require("../icon");
const text_input_1 = __importDefault(require("./text-input"));
/**
 * Specialized text input that will automatically format the content. The format can either be a
 * pre-defined one (such as, 'monetary', 'monetary-decimal', or 'ssn'). Or it can be a custom
 * format. When defininig a custom format, use '0' to represent numberic characters, and 'A' to
 * represent alphabetic characters. For example, a phone number can be represented as, "(000) 000-0000".
 * Or, "0A0 A0A" would match "8T2 C7M".
 */
const FormattedInput = (_a) => {
    var { type = 'text', value = '', format = undefined, customFormat = undefined, obscurable = false, onChange = utils_1.noop, onBlur = utils_1.noop, onFocus = utils_1.noop, onKeyDown = utils_1.noop, onKeyUp = utils_1.noop, onClick = utils_1.noop, onMaskedChange = utils_1.noop, disabled = false, visibilityToggleLabel = 'Toggle visibility', valid = false, hint } = _a, props = __rest(_a, ["type", "value", "format", "customFormat", "obscurable", "onChange", "onBlur", "onFocus", "onKeyDown", "onKeyUp", "onClick", "onMaskedChange", "disabled", "visibilityToggleLabel", "valid", "hint"]);
    let mask = '';
    if (customFormat !== undefined) {
        mask = customFormat;
    }
    else if (format === 'monetary') {
        mask = '$#';
    }
    else if (format === 'monetary-decimal') {
        mask = '$#.00';
    }
    else if (format === 'ssn') {
        mask = '000-00-0000';
    }
    const [initialRaw, initialMasked] = format_mask_1.applyMask(mask, value);
    const [rawValue, setRawValue] = react_1.useState(initialRaw);
    const [maskedValue, setMaskedValue] = react_1.useState(initialMasked);
    react_1.useEffect(() => {
        const [raw, masked] = format_mask_1.applyMask(mask, value);
        setRawValue(raw);
        setMaskedValue(masked);
    }, [mask, value]);
    const [obscured, setObscured] = react_1.useState(obscurable);
    const toggleVisibility = () => setObscured(!obscured);
    const handleChange = (newValue, e) => {
        const [newRawValue, newMaskedValue] = format_mask_1.applyMask(mask, newValue);
        if (newMaskedValue !== maskedValue) {
            setRawValue(newRawValue);
            setMaskedValue(newMaskedValue);
            onChange(newRawValue);
            onMaskedChange(newMaskedValue);
        }
        // needed for preact since it doesn't rerender if the value doesn't change
        e.target.value = obscured ? newRawValue : newMaskedValue;
    };
    const visibilityIcon = (react_1.default.createElement(icon_1.IconButton, { name: obscured ? 'visibility' : 'visibility_off', onClick: toggleVisibility, disabled: disabled, ariaPressed: !obscured, ariaLabel: visibilityToggleLabel }));
    return (react_1.default.createElement(text_input_1.default, Object.assign({ type: obscured ? 'password' : type, value: obscured ? rawValue : maskedValue, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onClick: onClick, icon: obscurable ? visibilityIcon : undefined, iconPosition: "right", disabled: disabled, valid: valid, hint: hint }, props)));
};
exports.FormattedInput = FormattedInput;
exports.default = exports.FormattedInput;
